import { computed, type InjectionKey, reactive } from "vue";

export function createPerformancePickerGate(enabled: () => boolean = () => true, activePicker?: () => string | null) {
    const openPickers = reactive(new Set<string>());
    return {
        isOpen: computed(() => enabled() && (activePicker ? openPickers.has(activePicker() ?? "") : openPickers.size > 0)),
        setOpen(key: string, open: boolean) {
            if (open) {
                openPickers.add(key);
            } else {
                openPickers.delete(key);
            }
        },
    };
}

export const performancePickerGateKey: InjectionKey<ReturnType<typeof createPerformancePickerGate>> = Symbol("performancePickerGate");
